import { routeAlias, routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const practiceTypeRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.practiceTypes,
    name: routeNames.practiceTypes,
    component: () => import('@/pages/practice-types/PracticeTypesView.vue'),
    meta: {
      permission: 'practice-type.read.all',
      icon: 'material-symbols-outlined',
      iconText: 'difference',
      labelKey: 'practiceTypes',
    },
  },
  {
    path: routePaths.practiceTypeDetails,
    component: () => import('@/pages/practice-types/PracticeTypeDetailsView.vue'),
    meta: { permission: 'practice-type.read.all', rootRouteName: routeNames.practiceTypes },
    children: [
      {
        path: '',
        name: routeNames.practiceTypeDetails,
        redirect: ({ params }) => ({ name: routeNames.practicePhases, params }),
      },
      {
        path: routePaths.practicePhases,
        name: routeNames.practicePhases,
        component: () => import('@/pages/practice-types/phases/PracticePhasesTab.vue'),
        meta: {
          permission: 'practice-type.read.all',
          labelKey: 'practicePhases',
        },
      },
      {
        path: routePaths.practiceTypeRecordTypes,
        name: routeNames.practiceTypeRecordTypes,
        component: () => import('@/pages/practice-types/practice-record-types/PracticeRecordTypesTab.vue'),
        meta: {
          permission: 'practice-type.read.all',
          labelKey: 'practiceTypeRecordTypes',
          featureFlag: 'records',
        },
      },
      {
        path: routePaths.practiceTypeRecordTools,
        name: routeNames.practiceTypeRecordTools,
        component: () => import('@/pages/practice-types/record-tools/PracticeRecordToolsTab.vue'),
        meta: {
          permission: 'practice-type.read.all',
          labelKey: 'practiceTypeRecordTools',
        },
      },
      {
        path: routePaths.practiceTypeAssignmentRoles,
        name: routeNames.practiceTypeAssignmentRoles,
        component: () => import('@/pages/practice-types/assignment-roles/PracticeAssignmentRolesTab.vue'),
        meta: {
          permission: 'practice-type.read.all',
          labelKey: 'practiceTypeAssignmentRoles',
        },
      },
      {
        path: routePaths.practiceTypeDeadlineTypes,
        name: routeNames.practiceTypeDeadlineTypes,
        component: () => import('@/pages/practice-types/deadline-types/DeadlineTypesTab.vue'),
        meta: {
          permission: 'practice-type.read.all',
          labelKey: 'practiceTypeDeadlineTypes',
          featureFlag: 'deadlines',
        },
      },
    ],
  },
  {
    path: routePaths.practiceTypeCreation,
    name: routeNames.practiceTypeCreation,
    component: () => import('@/pages/practice-types/AddEditPracticeTypeView.vue'),
    meta: {
      permission: 'practice-type.write.all',
      labelKey: 'new_m',
      rootRouteName: routeNames.practiceTypes,
    },
  },
  {
    path: routePaths.practiceTypeEdit,
    name: routeNames.practiceTypeEdit,
    component: () => import('@/pages/practice-types/AddEditPracticeTypeView.vue'),
    meta: {
      permission: 'practice-type.write.all',
      labelKey: 'edit',
      rootRouteName: routeNames.practiceTypes,
    },
  },
  {
    path: routePaths.practicePhaseCreation,
    name: routeNames.practicePhaseCreation,
    component: () => import('@/pages/practice-types/phases/AddEditPracticePhaseView.vue'),
    meta: {
      permission: 'practice-type.write.all',
      labelKey: 'new_f',
      rootRouteName: routeNames.practiceTypes,
    },
  },
  {
    path: routePaths.practicePhaseEdit,
    name: routeNames.practicePhaseEdit,
    alias: routeAlias.practicePhaseEdit,
    component: () => import('@/pages/practice-types/phases/AddEditPracticePhaseView.vue'),
    meta: {
      permission: 'practice-type.write.all',
      labelKey: 'edit',
      rootRouteName: routeNames.practiceTypes,
    },
  },
]
